import {toast} from "react-toastify";


toast.onChange(payload => {
    if (payload.status === "added" && payload.type === toast.TYPE.SUCCESS) {
        toast.update(payload.id, {
            autoClose: process.env.REACT_APP_NOTIFICATIONS_AUTOCLOSE_TIME && !isNaN(Number(process.env.REACT_APP_NOTIFICATIONS_AUTOCLOSE_TIME)) ? Number(process.env.REACT_APP_NOTIFICATIONS_AUTOCLOSE_TIME) : 5000
        });
    }
});